import { ColorDot } from '@/components/ui/color-dot'

interface StatusBadgeProps {
  name: string | null
  color: string | null
}

export function StatusBadge({ name, color }: StatusBadgeProps) {
  if (!name) {
    return <span className="text-xs text-muted-foreground">—</span>
  }
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-border bg-secondary px-2 py-0.5 text-xs text-muted-foreground">
      <ColorDot color={color ?? '#6b7280'} size="sm" />
      {name}
    </span>
  )
}
